export default __webpack_public_path__ + "static/media/copy_icn.4ccb0872.svg";